export default {
  push_notification: {},
};
